import ScalarErrorBoundary_vue_vue_type_script_setup_true_lang_default from "./ScalarErrorBoundary.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarErrorBoundary/ScalarErrorBoundary.vue
var ScalarErrorBoundary_default = ScalarErrorBoundary_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarErrorBoundary_default as default };

//# sourceMappingURL=ScalarErrorBoundary.vue.js.map